module.exports = __webpack_public_path__ + "static/object-detector-demo-a3bac22d25874df7c81249e6e540dc37.jpg";